import { SIMPLE_EMAIL_REGEX } from '@naturalcycles/js-lib'

export enum ValidationType {
  'Email' = 'Email',
  'Tel' = 'Tel',
}

export function checkValidation(value: string | number, type: ValidationType | number): boolean {
  const checkValue = value.toString()

  switch (type) {
    case ValidationType.Email: {
      return SIMPLE_EMAIL_REGEX.test(checkValue)
    }

    case ValidationType.Tel: {
      // checks for format +123 and 123
      return /^([0-9/+])*$/.test(checkValue)
    }

    default: {
      return false
    }
  }
}
